import { render } from "./DropDownInfoNumbered.vue?vue&type=template&id=3b94177a&scoped=true"
import script from "./DropDownInfoNumbered.vue?vue&type=script&lang=js"
export * from "./DropDownInfoNumbered.vue?vue&type=script&lang=js"

import "./DropDownInfoNumbered.vue?vue&type=style&index=0&id=3b94177a&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b94177a"]])

export default __exports__